module.exports = __webpack_public_path__ + "img/hi.140b6d76.png";